/**
 * Pure helpers for /settings/branding — extracted so they can be unit-tested
 * without pulling in the full route module's React/TanStack/QueryClient tree.
 */

const COLOR_PICKER_DEFAULT = "#2563eb";

/**
 * Expand a 3-digit hex (`#f0f`) to its 6-digit form (`#ff00ff`) so the native
 * `<input type="color">` swatch shows the user's actual brand color. For
 * empty/invalid input return the ProvenLeap default — the native picker
 * REQUIRES a 6-digit hex, and falsely showing black implies black is the
 * brand color (CR1 M7 / CR2 R2-F7).
 */
export function expandHexForPicker(hex: string): string {
  const trimmed = hex.trim();
  if (/^#([0-9a-fA-F]{6})$/.test(trimmed)) return trimmed;
  const match = trimmed.match(/^#([0-9a-fA-F]{3})$/);
  if (match && match[1]) {
    const [r, g, b] = match[1].split("");
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return COLOR_PICKER_DEFAULT;
}
